import React, { useEffect, useCallback, useState, useRef } from "react";
import { useClientInformationContext } from "../../Context/ClientInformation";
import {
  ContactInformation,
  ShippingAndBillingAddress,
  TermsOfSales,
  ThankYou,
} from "./";

import axios from 'axios'
import "../css/ClientCss/ClientHeader.css";
import "../css/ClientCss/ClientBody.css";
import { useNavigate } from "react-router-dom";
import { toast} from "react-toastify";
import { LoadingScreen } from "../LoadingScreen";
 
 
 const CallClientInformationForm = () => {
  const { tokenData, SERVER_URL, myImage, sessionNewEmailId,customerTypeData,categoryData,userList } = useClientInformationContext();
  const [step, setStep] = useState(1);
  const [invalidFields, setInvalidFields] = useState([]);
  const [errorMessage,setErrorMessage] = useState([])
  const [isLoading,setIsLoading] = useState(false)
  const [shippingZipCodeError, setShippingZipCodeError] = useState("");
  const [billingZipCodeError, setBillingZipCodeError] = useState("");
  const navigate = useNavigate();
  const [touchedFields, setTouchedFields] = useState({});
  const [isEmailEnabled, setIsEmailEnabled] = useState(false);
  const isNewCustomer = localStorage.getItem('validNewCustomer') === 'true';
  useEffect(() => {
    // Read scannedQR value from localStorage
    const scannedQR = localStorage.getItem('scannedQR') === 'true';
    setIsEmailEnabled(scannedQR);
  }, []);
   const [showBillingDetails, setShowBillingDetails] = useState(true);
   const [formData, setFormData] = useState({
    hearAboutUs: "",
    companyName: "",
    contactFirstName: "",
    contactLastName: "",
    email: sessionNewEmailId,
    phoneNumber: "",
    customerType: [],
    businessCategory: [],
    salesRep: "",
    addressesSame: "",
    shippingAddressLine1: "",
    shippingAddressLine2: "",
    shippingCity: "",
    shippingState: "",
    shippingZipCode: "",
    shippingCountry: "",
    billingStreetAddress: "",
    billingSuite: "",
    billingCity: "",
    billingState: "",
    billingZipCode: "",
    billingCountry: "",
    termsAccepted: false,
    jobTitle: "",
    date: "",
    clientsignature: "",
  });

  const [phone, setPhone] = useState(formData.phoneNumber);
   // disply the phone no from the api in the UI
   useEffect(() => {
    setPhone(formData.phoneNumber);
  }, [formData.phoneNumber]);
  // const salesReps = [
  //   // { label: "Guest One", value: "65511f1a-7689-ee11-8179-000d3a3413b7" },
  //   { label: "Anthony Gabriel", value: process.env.REACT_APP_ANTHONY_GABRIEL_VALUE },
  //   { label: "Anastasia Bolbat", value: process.env.REACT_APP_ANASTASIA_BOLBAT_VALUE },
  //   { label: "Carolyn Garner", value: process.env.REACT_APP_CAROLYN_GARNER_VALUE },
  //   { label: "Genesis Castillo", value: process.env.REACT_APP_GENESIS_CASTILLO_VALUE },
  //   { label: "Jordan Rezak", value: process.env.REACT_APP_JORDAN_REZAK_VALUE },
  //   { label: "Luis De La Rosa", value: process.env.REACT_APP_LUIS_DE_LA_ROSA_VALUE },
  //   { label: "Robert Rezak", value: process.env.REACT_APP_ROBERT_REZAK_VALUE },
  //   { label: "Stephanie Vega", value: process.env.REACT_APP_STEPHANIE_VEGA_VALUE },
  //   { label: "None of the Above", value: "none_of_the_above" }
  // ];
  var salesReps = userList;
 
 useEffect(()=>{
  console.log("userlist changes",userList);
  salesReps = userList;
 },[userList])
  
 const [selectedCustomerTypes, setSelectedCustomerTypes] = useState(
  customerTypeData.filter((option) =>
    (formData.customerType || []).includes(option.value)
  )
);

const [selectedCategories, setSelectedCategories] = useState(
  categoryData.filter((option) =>
    (formData.businessCategory || []).includes(option.value)
  )
);

useEffect(() => {
  const fetchCustomerDetails = async () => {
    const storedTokenData = localStorage.getItem("auth-token");
    if (!storedTokenData || !formData.email) return;

    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/api/optionsetData/fetchEmailContactDetails`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            tokenData: storedTokenData,
            email: formData.email,
          }),
        }
      );
      if (response.status === 404) {
        console.log("No account found with this email.");
      }        
      if (!response.ok) {
        throw new Error("Failed to fetch customer details");
      }
      const data = await response.json();
      console.log("SET FORM DATA", data, 93);
        const customerTypeArray = data.customerType
          ? data.customerType.split(",").map((type) => type.trim())
          : []; // Default to an empty array if null or undefined

        const businessCategoryArray = data.businessCategory
          ? data.businessCategory.split(",").map((category) => category.trim())
          : []; // Default to an empty array if null or undefined

        setFormData((prevFormData) => ({
          ...prevFormData,
          ...data,
          customerType: customerTypeArray, // Ensure it's an array
          businessCategory: businessCategoryArray, // Ensure it's an array
        }));
        // Update selected options in multi-select
        setSelectedCustomerTypes(
          customerTypeData.filter((option) =>
            customerTypeArray.includes(option.value)
          )
        );
        setSelectedCategories(
          categoryData.filter((option) =>
            businessCategoryArray.includes(option.value)
          )
        );
    } catch (error) {
      console.log("Error", error);
    }
  };

  fetchCustomerDetails();
}, [formData.email, customerTypeData, categoryData]);
 
  console.log("SetFormData", formData);
 
  const handleChange = useCallback((e, fieldName) => {
    let name, value, type, checked;
 
    if (e && e.target) {
      ({ name, value, type, checked } = e.target);
    } else {
      name = fieldName;
      value = e;
    }
 
    if (type === "checkbox") {
      value = checked;
    }
 
    setFormData((prevData) => {
      const newFormData = {
        ...prevData,
        [name]: value,
      };
      // Store customerType and businessCategory in session storage
      if (name === "customerType" || name === "businessCategory") {
        sessionStorage.setItem(name, JSON.stringify(value));
      }
      if (name === "shippingAddressLine1" || name === "shippingAddressLine2") {
        const addressesSame = parseInt(localStorage.getItem('addressesSame'), 10);
        console.log("addressesSame", addressesSame);
     
        if (addressesSame === 1) {
          console.log("you are here");
     
          // Update the corresponding billing address fields
          if (name === "shippingAddressLine1") {
            console.log("your value is", value);
            newFormData.billingStreetAddress = value; // Update billingStreetAddress
          } else if (name === "shippingAddressLine2") {
            console.log("your value is", value);
            newFormData.billingSuite = value; // Update billingSuite
          }
     
          // Execute these statements once after updating any of the fields
          // setShowBillingDetails(true);
          // localStorage.setItem("addressesSame", 0);
        }
      }
      // Store salesRep in sessionStorage
    if (name === "salesRep") {
      // If "None Of the Above" is selected, set the formData to a specific value
      if (value === "none_of_the_above") {
        newFormData[name] = sessionStorage.getItem('none_of_above_user');
        newFormData.salesRepLabel = "None of the Above";
      } else {
        const selectedRep = salesReps.find(rep => rep.value === value);
        newFormData.salesRepLabel = selectedRep ? selectedRep.label : '';
      }
      sessionStorage.setItem("salesrepwhoreachedouttoyou", newFormData[name]);
    }
        
      // Remove the field from invalidFields if it's filled
      setInvalidFields((prevInvalidFields) =>
        prevInvalidFields.filter((field) => field !== name)
      );
 
      return newFormData;
    });
  }, []);
 
  const handleToggleChange = (checked) => {
    setShowBillingDetails(!checked); // Update showBillingDetails state based on toggle
    localStorage.setItem("addressesSame", checked ? "1" : "0"); // Update local storage value
 
    // If addresses are the same, copy shipping details to billing details
    if (checked) {
      handleChange({
        target: {
          name: "billingStreetAddress",
          value: formData.shippingAddressLine1,
        },
      });
      if (formData.shippingAddressLine2 !== null) {
        handleChange({
          target: { name: "billingSuite", value: formData.shippingAddressLine2 },
        });
      }
      handleChange({
        target: { name: "billingCountry", value: formData.shippingCountry },
      });
      handleChange({
        target: { name: "billingState", value: formData.shippingState },
      });
      handleChange({
        target: { name: "billingCity", value: formData.shippingCity },
      });
      handleChange({
        target: { name: "billingZipCode", value: formData.shippingZipCode },
      });
    } else {
      handleChange({
        target: { name: "billingStreetAddress", value: "" },
      });
      handleChange({
        target: { name: "billingSuite", value: "" },
      });
      handleChange({
        target: { name: "billingCountry", value: "" },
      });
      handleChange({
        target: { name: "billingState", value: "" },
      });
      handleChange({
        target: { name: "billingCity", value: "" },
      });
      handleChange({
        target: { name: "billingZipCode", value: "" },
      });
    }
  };
  // const handleChange = useCallback((e, fieldName) => {
  //   if (e && e.target) {
  //     const { name, value, type, checked } = e.target;
  //     setFormData((prevData) => ({
  //       ...prevData,
  //       [name]: type === "checkbox" ? checked : value,
  //     }));
  //   } else {
  //     setFormData((prevData) => ({
  //       ...prevData,
  //       [fieldName]: e,
  //     }));
  //   }
  //   setInvalidFields((prevInvalidFields) =>
  //     prevInvalidFields.filter((field) => field !== name)
  //   );
  // }, []);
 
  // const nextStep = () => {
  //   if (step === 1) {
  //     setStep(2);
  //   } else if (step === 2) {
  //     setStep(3);
  //   }
  // };
 
  const containerRef = useRef(null);

  const nextStep = () => {
    const invalidField = validateFields();
    if (invalidField) {
      if(step === 1){
        window.scrollTo(0, 0);
      }
      else if(step === 2){
        window.scrollTo(0, 0);
      }
       
    } else {
      setStep( (prevStep) => {
        prevStep = prevStep + 1;
        return prevStep;
      });
    }
   
  };

  const prevStep = () => {
    if (step > 1) {
      setStep(prevStep => prevStep - 1);
    }
  };

  // useEffect(() => {
  //   if (containerRef.current) {
  //     containerRef.current.scrollTo(0, 0);
  //   } else {
  //     window.scrollTo(0, 0);
  //   }
  // }, [step]);
 

  const validateFields = () => {
     const requiredFieldsStep1 = [ "contactFirstName", "contactLastName", "email", "phone","hearAboutUs", "customerType","businessCategory" ,"salesRep", "companyName"];
     const requiredFieldsStep2 = ["shippingAddressLine1","shippingCountry", "shippingState", "shippingCity",  "shippingZipCode","billingStreetAddress","billingCity", "billingState", "billingZipCode", "billingCountry"];
     const requiredFieldsStep3 = ["termsAccepted", "jobTitle", "clientsignature"];
  
     const fieldsToValidate = step === 1 ? requiredFieldsStep1 :
                             step === 2 ? requiredFieldsStep2 :
                             requiredFieldsStep3;
  
     const invalids = fieldsToValidate.filter(field => !formData[field]);
  
     // Add zip code errors to invalid fields
   if (shippingZipCodeError.length > 0) invalids.push("shippingZipCode");
   if (billingZipCodeError.length > 0) invalids.push("billingZipCode");
   // // error for multiselect field
   if(selectedCustomerTypes.length<1)  invalids.push("customerType");
   if(selectedCategories.length<1)  invalids.push("businessCategory");
  
   // Update touched fields for all required fields
   const newTouchedFields = {};
   fieldsToValidate.forEach((field) => {
     newTouchedFields[field] = true;
   });
   setTouchedFields(newTouchedFields);
  
     setInvalidFields(invalids);
     return invalids.length > 0 ? invalids[0] : null;
   };
  var sign = sessionStorage.getItem('signature');
 
  // const validateFields = () => {
  //   const requiredFieldsStep1 = ["contactFirstName", "hearAboutUs", "companyName", "contactFirstName", "contactLastName", "email", "phoneNumber"];
  //   const requiredFieldsStep2 = ["shippingAddressLine1", "shippingCity", "shippingState", "shippingZipCode", "shippingCountry", "billingStreetAddress", "billingCity", "billingState", "billingZipCode", "billingCountry"];
  //   const requiredFieldsStep3 = ["termsAccepted", "jobTitle", "date", "clientsignature"];
 
  //   const fieldsToValidate = step === 1 ? requiredFieldsStep1 :
  //                           step === 2 ? requiredFieldsStep2 :
  //                           requiredFieldsStep3;
 
  //   for (const field of fieldsToValidate) {
  //     if (!formData[field]) {
  //       return field;
  //     }
  //   }
  //   return null;
  // };


  // useEffect(() => {
  //   const token = localStorage.getItem('120MinToken');
  //   const handleClientInvalidToken = () => {
  //     caches.keys().then(names => {
  //       names.forEach(name => {
  //         if (name !== 'cart-product-cache') {
  //           caches.delete(name);
  //         }
  //       });
  //     });
  //     setTimeout(() => {
  //     sessionStorage.clear();
  //     localStorage.clear();
  //       window.location.href = "/";
  //     }, 3000);
  //   };
    
  //   const newUserEmail = sessionStorage.getItem('NewUserEmail')
  //   const isNewCustomer = localStorage.getItem('validNewCustomer') === 'true';
  //   const userExist = sessionStorage.getItem('userExists') === 'true'
  //   // Function to validate the token and, if necessary, check email
  //   const validateToken = async () => {
  //     try {
  //       const response = await axios.post(
  //         `${process.env.REACT_APP_SERVER_URL}/api/auth/verify/validate-token`,
  //         { token }
  //       );

  //       if (response.data.message === 'Token is valid') {
  //         if (isNewCustomer&& !userExist && response.data.data.email !== newUserEmail) {
  //           handleClientInvalidToken();
  //         } else {
  //           return;
  //         }
  //       } else {
  //         return
  //       }
  //     } catch (error) {
  //       console.log("error", error)
  //     }
  //   };
  //     validateToken();
  // }, [isNewCustomer]);


  const copyShippingToBillingDetails = () => {
    const isBillingEmpty =
      !formData?.billingStreetAddress ||
      !formData?.billingSuite ||
      !formData?.billingCity ||
      !formData?.billingState ||
      !formData?.billingZipCode ||
      !formData?.billingCountry;
   
    const isShippingFilled =
      (formData?.shippingAddressLine1?.trim() !== "" || "") &&
      (formData?.shippingCity?.trim() !== "" || "") &&
      (formData?.shippingState?.trim() !== "" || "") &&
      (formData?.shippingZipCode?.trim() !== "" || "") &&
      (formData?.shippingCountry?.trim() !== "" || "");
   
    const addressesSame = localStorage.getItem('addressesSame');
    const isAddressesSame = addressesSame === "1";
   
    console.log("isBillingEmpty :", isBillingEmpty);
    console.log("isShippingFilled :", isShippingFilled);
    console.log("addressesSame :", addressesSame);
   
    if (isBillingEmpty && isShippingFilled && isAddressesSame) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        billingStreetAddress: formData.shippingAddressLine1,
        billingSuite: formData.shippingAddressLine2 ? formData.shippingAddressLine2 : prevFormData.billingSuite,
        billingCountry: formData.shippingCountry,
        billingState: formData.shippingState,
        billingCity: formData.shippingCity,
        billingZipCode: formData.shippingZipCode,
      }));
      return true;
    }
    return false;
  };
  const handleNextButtonClick = () => {
    if (step === 2) {
      const billingCopied = copyShippingToBillingDetails();
      console.log("billingCopied",billingCopied);
      console.log("Form data 254",formData);
      if (billingCopied || !billingCopied) {
        nextStep();
      }
    } else if (step !== 3) {
      nextStep();
    } else {
      handleSubmit();
    }
  };

  const handleSubmit = async (e) => {
    // e.preventDefault(); // Prevent the default form submission
    setIsLoading(true); // Set loading to true
    if (!formData.termsAccepted) {
      setIsLoading(false);
      toast.error("You must accept the terms and conditions");
      return;
    }
 
    var esign = sessionStorage.getItem('signature');
     
      if (!esign) {
          setIsLoading(false);
          toast.error("Please do your signature.");
          return;
      }
   
    // Validate required fields
    if (step === 3 && !formData.jobTitle) {
      setIsLoading(false);
      toast.error("Job title is required");
      return;
    }
 
   
 
    // Check for other required fields and show error if any are missing
    if (!formData.companyName || !formData.contactFirstName || !formData.contactLastName ||
        !formData.email || !formData.phone || !formData.customerType ||
        !formData.businessCategory || !formData.shippingAddressLine1 ||
        !formData.shippingCity || !formData.shippingState ||
        !formData.shippingZipCode || !formData.shippingCountry ||
        !formData.billingStreetAddress || !formData.billingCity ||
        !formData.billingState || !formData.billingZipCode ||
        !formData.billingCountry) {
      setIsLoading(false);
      toast.error("Please fill all required details");
      return;
    }
 
    try {
      const leadData = {
        topic: formData.hearAboutUs,
        companyname: formData.companyName,
        firstname: formData.contactFirstName,
        lastname: formData.contactLastName,
        emailaddress: formData.email,
        phonenumber: formData.phone,
        customertype: formData.customerType,
        selectthecategory: formData.businessCategory,
        shippingaddressline1: formData.shippingAddressLine1,
        shippingaddressline2: formData.shippingAddressLine2 || "",
        shippingcity: formData.shippingCity,
        shippingstate: formData.shippingState,
        shippingzipcode: formData.shippingZipCode,
        shippingcountry: formData.shippingCountry,
        salesrepwhoreachedouttoyou: formData.salesRep,
        billingstreetaddress: formData.billingStreetAddress,
        billingsuitedoc: formData.billingSuite,
        billingcity: formData.billingCity,
        billingstate: formData.billingState,
        billingzipcode: formData.billingZipCode,
        billingcountry: formData.billingCountry,
        jobtitle: formData.jobTitle,
        date: formData.date,
        clientsignature: sign.split(',')[1],
      };
 
      console.log("Print lead data:", JSON.stringify(leadData, null, 2));
 
      const apiEndpointURL =
        `${process.env.REACT_APP_CRM_URL}nyc_apinewclientapplication`;
      const response = await fetch(apiEndpointURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenData}`,
        },
        body: JSON.stringify(leadData),
      });
 
      if (response.ok) {
        sessionStorage.removeItem('signature');
        const responseText = await response.text();
        console.log("API response text:", responseText);
 
        // Parse the response JSON
        const jsonResponse = JSON.parse(responseText);
        const apiResponse = jsonResponse.apiresponse;
 
        // Extract key-value pairs from the apiresponse field
        const responseParts = apiResponse.split(", ");
        const responseData = {};
        responseParts.forEach((part) => {
          const [key, value] = part.split(": ");
          responseData[key.trim()] = value.trim();
        });
 
        console.log("Parsed response data:", responseData);
 
        if (responseData.accountid || responseData.contactid) {
          const cache = await caches.open('user-data-cache');
        const request = new Request('/user-data'); // Dummy endpoint to key the data
        const response = new Response(JSON.stringify({
           contactId: responseData.contactid,
            accountId: responseData.accountid,
           }), {
            headers: { 'Content-Type': 'application/json' }
        });
 
        // Store the response in the cache
        await cache.put(request, response);}
        //sessionStorage.setItem("accountId", responseData.accountid);
        //if (responseData.contactid)
        //sessionStorage.setItem("contactId", responseData.contactid);
        if (responseData.opportunityid) localStorage.setItem("opportunityId", responseData.opportunityid);
        const selectedLabels = selectedCategories.map(category => category.label);
        localStorage.setItem("selectedCategories", JSON.stringify(selectedLabels));
        toast.success("Form data submitted successfully!");
        console.log("Form Data Submitted:", formData);
        localStorage.setItem("validWithOTP", true);
        localStorage.setItem("callApiData", true)
        localStorage.setItem("validSalesPerson", false);
        localStorage.setItem("validNewCustomer", false);
        localStorage.setItem("newUserValidation", false)
        localStorage.removeItem('scannedQR');
        setTimeout(() => {
          setIsLoading(false);
          navigate("/home/inventory");
          window.location.reload();
        }, 3000);
      } else {
        const responseData = await response.json();
        setIsLoading(false);
        toast.error("Something went wrong! Please try again");
        console.error("Error response:", responseData);
      }
    } catch (error) {
      console.error("Error submitting form data:", error);
      setIsLoading(false);
      toast.error("Failed to submit form data. Please try again");
    } finally {
      localStorage.setItem('newCustomer', 'true');
      localStorage.removeItem("addressesSame");
    }
  };
 
  const handleStepChange = (stepNumber) => {
    setStep(stepNumber);
  };
  useEffect(() => {
    localStorage.setItem('addressesSame',0);
}, []);
 
useEffect(() => {
  let currentIndex = window.history.state?.index || 0;
 
  const handleNavigation = (event) => {
    const delta = event.state?.index ? event.state.index - currentIndex : 0;
    if (delta === 1) {
      // Forward button was clicked
      nextStep();
    } else if (delta === -1) {
      // Back button was clicked
      prevStep();
    }
    currentIndex = event.state?.index || currentIndex;
  };
 
  // Push initial state
  window.history.replaceState({ index: currentIndex }, '');
 
  // Push a new state to enable back button
  window.history.pushState({ index: currentIndex + 1 }, '');
 
  window.addEventListener('popstate', handleNavigation);
 
  return () => {
    window.removeEventListener('popstate', handleNavigation);
  };
}, [nextStep, prevStep]);
  return (
    <div className="app">
       <>
       {isLoading && <LoadingScreen />}
          <div className="fixed z-10 text-center top-0 min-w-full flex flex-col justify-center items-center bg-white box-border shadow-sm font-bold rounded-md nycfix-form-navbar">
            <div className="flex items-center col-lg-11 p-2">
              <div className="">
                <img src={myImage} alt="NYC Logo" className="client-photo" />
              </div>
              <div className="flex justify-center items-center text-2xl w-full">
                <h2>Customer Information Form</h2>
              </div>
            </div>
            {/* <div className="steps">
              <div className={`step ${step === 1 ? "active" : ""}`}>
                <div className={`step-number ${step === 1 ? "active" : ""}`}>
                  1
                </div>
                Contact & Company Information
              </div>
              <div className="step1">
                <div className="bar"></div>
              </div>
              <div className={`step ${step === 2 ? "active" : ""}`}>
                <div className={`step-number ${step === 2 ? "active" : ""}`}>
                  2
                </div>
                Shipping & Billing Address
              </div>
              <div className="step1">
                <div className="bar"></div>
              </div>
              <div className={`step ${step === 3 ? "active" : ""}`}>
                <div className={`step-number ${step === 3 ? "active" : ""}`}>
                  3
                </div>
                Terms of Sales & Consent
              </div>
            </div> */}
            <div className="steps nycfix-info-form-nav">
              <div
                className={`step ${step === 1 ? "active" : ""}`}
                id="nycfix-navcols"
                onClick={() => handleStepChange(1)}
              >
                <div className={`step-number ${step === 1 ? "active" : ""}`}>
                  1
                </div>
                Contact & Company Information
              </div>
              <div className="step1">
                <div className="bar"></div>
              </div>
              <div
                className={`step ${step === 2 ? "active" : ""}`}
                id="nycfix-navcols"
                onClick={() => handleStepChange(2)}
              >
                <div className={`step-number ${step === 2 ? "active" : ""}`}>
                  2
                </div>
                Shipping & Billing Address
              </div>
              <div className="step1">
                <div className="bar"></div>
              </div>
              <div
                className={`step ${step === 3 ? "active" : ""}`}
                id="nycfix-navcols"
                onClick={() => handleStepChange(3)}
              >
                <div className={`step-number ${step === 3 ? "active" : ""}`}>
                  3
                </div>
                Terms of Sales & Consent
              </div>
            </div>
          </div>

          <div className="flex-1 bg-white max-h-full w-full mt-12 flex justify-center nycfix-form-cont">
            <div className="w-10/12 box-border shadow-md bg-[#FFEDEF]">
              <form>
                {step === 1 && (
                  <ContactInformation
                     salesReps = {salesReps}
                    formData={formData}
                    handleChange={handleChange}
                    invalidFields={invalidFields}
                    errorMessage={errorMessage}
                    selectedCustomerTypes={selectedCustomerTypes}
                    setSelectedCustomerTypes={setSelectedCustomerTypes}
                    selectedCategories={selectedCategories}
                    setSelectedCategories={setSelectedCategories}
                    phone = {phone} 
                    setPhone = {setPhone}
                    isEmailEnabled={isEmailEnabled}
                  />
                )}
                {step === 2 && (
                  <ShippingAndBillingAddress
                    formData={formData}
                    handleChange={handleChange}
                    invalidFields={invalidFields}
                    errorMessage={errorMessage}
                    shippingZipCodeError={shippingZipCodeError}
                    setShippingZipCodeError={setShippingZipCodeError}
                    billingZipCodeError={billingZipCodeError}
                    setBillingZipCodeError={setBillingZipCodeError}
                    setFormData={setFormData}
                    showBillingDetails = {showBillingDetails}
                    setShowBillingDetails ={setShowBillingDetails}
                    handleToggleChange={handleToggleChange}
                    touchedFields ={touchedFields}
                    setTouchedFields ={setTouchedFields}
     
                  setInvalidFields={setInvalidFields}
                  />
                )}
                {step === 3 && (
                  <TermsOfSales
                    formData={formData}
                    handleChange={handleChange}
                    invalidFields={invalidFields}
                    errorMessage={errorMessage}
                  />
                )}
                <div className="buttonPlacing">
                  {step > 1 && (
                    <button
                      type="button"
                      className="prev-button"
                      onClick={prevStep}
                    >
                      Previous
                    </button>
                  )}
                  {/* <button
                  type="button"
                  className="next-button"
                  onClick={() => {
                    if (step !== 3) {
                      nextStep();
                    } else {
                      handleSubmit();
                    }
                  }}
                >
                  {step === 3 ? "Submit" : "Next"}
                </button> */}
                 <button
                  type="button"
                  className="next-button"
                  onClick=
 
                    {handleNextButtonClick}
                >
                  {step === 3 ? "Submit" : "Next"}
                </button>
                </div>
              </form>
            </div>
          </div>
        </>
    </div>
  );
};
 
export default CallClientInformationForm;